import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import React, { useCallback, useEffect, useRef, useState } from "react";

interface BasePageModalProps {
  className?: string; // モーダルのメインコンテンツ(sectionの中身)のクラス名
  handleClose: () => void; // 閉じる（キャンセル）ボタン押下時のイベント
  children?: React.JSX.Element | Array<React.JSX.Element>; // ボディ部
  bottomChildren?: React.JSX.Element | Array<React.JSX.Element>; // フッター部に追加する要素
  headerContent?: React.JSX.Element; // ヘッダー部に追加する要素
  hideCloseButton?: boolean; // closeModalボタンを非表示にするかどうか
}

export const BasePageModalForCamera = (props: BasePageModalProps) => {
  const {
    className = "",
    children,
    bottomChildren,
    handleClose,
    headerContent,
    hideCloseButton = false,
  } = props;

  const [isClosing, setIsClosing] = useState(false);
  const modalRef = useRef<HTMLElement>(null);

  const handleCloseClick = () => {
    setIsClosing(true);
    setTimeout(() => {
      handleClose(); // 親に閉じてもらう
    }, 200); // ← CSSのtransitionと合わせる
  };

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key !== "Tab" || !modalRef.current) return;

    const focusableElements = Array.from(
      modalRef.current.querySelectorAll<HTMLElement>(
        'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => {
      if (["SECTION", "DIV", "ASIDE"].includes(el.tagName)) return false;
      const style = window.getComputedStyle(el);
      return style.display !== "none" && style.visibility !== "hidden";
    });
    if (focusableElements.length === 0) {
      e.preventDefault();
      modalRef.current.focus();
      return;
    }

    e.preventDefault();
    const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);
    let nextIndex: number;
    if (currentIndex === -1) {
      nextIndex = e.shiftKey ? focusableElements.length - 1 : 0;
    } else if (e.shiftKey) {
      nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
    } else {
      nextIndex = currentIndex === focusableElements.length - 1 ? 0 : currentIndex + 1;
    }
    focusableElements[nextIndex].focus();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [handleKeyDown]);

  useEffect(() => {
    requestAnimationFrame(() => {
      modalRef.current?.focus();
    });
  }, []);


//  useEffect(() => {
//    // FIXME: 直接DOMを触らないようにref等を使うよう修正するべき
//
//    // NOTE: Safari(iOS)でモーダル時にスクロールを行ったときに画面下をちらつかせないようにする対応
//    if (isShow) {
//      // BasePageModalを開くときにスタイルを当てて画面下をちらつかせないようにする対応
//      document.body.style.position = "fixed";
//      document.body.style.overflow = "hidden";
//      document.body.style.inset = "0px";
//      document.documentElement.style.height = "100vh";
//    } else {
//      // BasePageModalを閉じるときにスタイルをデフォルト値に戻す
//      document.body.style.position = "static";
//      document.body.style.overflow = "visible";
//      document.body.style.inset = "auto";
//      document.documentElement.style.height = "100%";
//    }
//
//    return () => {
//      document.body.style.position = "static";
//      document.body.style.overflow = "visible";
//      document.body.style.inset = "auto";
//      document.documentElement.style.height = "100%";
//    };
//  }, [isShow]);

//  // NOTE: Safari(iOS)で中央にグレーの点を表示させない対応
//  const innerAreaOnTapWrapper = (e: React.MouseEvent) => {
//    if (innerAreaOnTap) innerAreaOnTap();
//    e.stopPropagation();
//  };

  return (
    <>
      <div key="modalOverlay" id="modalOverlay" className={`overlay ${!isClosing ? "show" : ""}`}></div>
      <aside
        ref={modalRef}
        key="modalAside"
        id="modal"
        className={`modal-container ${!isClosing ? "show" : ""}`}
      >
        {!hideCloseButton &&
        <BaseRoundButton id="closeModal" className="btn-close" onClick={handleCloseClick} loadingNegative={true} />
        }
        <div className="modal-content fade-in">
          {headerContent}
          <section className={className}>
            {children}
          </section>
        </div>
      </aside>
    </>
  );
};
